import ROGBackground from "@components/layout/rog-background";
import useTranslator from "@hooks/use-translator";
import React, { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

const AuthLayout = ({ children }: Props) => {
  const { translate } = useTranslator();
  return (
    <ROGBackground>
      <div>{children}</div>
      <div className="gap 5px fixed bottom-0 flex justify-center py-4 text-sm text-white">
        <p>
          {translate("All Rights Reserved")} - {translate("Rog Tech Systems")}{" "}
          © {new Date().getFullYear()}
        </p>
      </div>
    </ROGBackground>
  );
};

export default AuthLayout;
